"use strict";
// write your code here
var logo = document.querySelector(".logo");
var successHandler = function() {
    var message = document.createElement("div");
    message.className = "message";
    message.textContent = "Promise was resolved!";
    document.body.append(message);
};
var errorHandler = function() {
    var message = document.createElement("div");
    message.className = "message error-message";
    message.textContent = "Promise was rejected!";
    document.body.append(message);
};
var promise1 = new Promise(function(resolve) {
    logo.addEventListener("click", function() {
        resolve();
    });
});
var promise2 = new Promise(function(resolve, reject) {
    setTimeout(function() {
        reject(new Error("Promise was rejected!"));
    }, 3000);
});
promise1.then(successHandler).catch(errorHandler);
promise2.then(successHandler).catch(errorHandler);

//# sourceMappingURL=index.ef0a44cc.js.map
